export type EducationearchTelemetryEvent =
  | "tc_search_submitted"
  | "tc_search_mode_toggled"
  | "tc_search_no_results"
  | "tc_search_advanced_suggested_clicked"
  | "tc_search_low_confidence_shown";

export type EducationearchTelemetryPayload = {
  eventType: EducationearchTelemetryEvent;
  occurredAtUtc?: string;
  metadata?: Record<string, string | number | boolean | null | undefined>;
};

function normalizeMetadata(metadata?: Record<string, string | number | boolean | null | undefined>) {
  if (!metadata) {
    return undefined;
  }

  return Object.fromEntries(
    Object.entries(metadata)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => [key, value === null ? null : String(value)])
  );
}

export async function trackEducationearchEvent(
  eventType: EducationearchTelemetryEvent,
  metadata?: Record<string, string | number | boolean | null | undefined>
) {
  try {
    await fetch("/api/education/telemetry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      keepalive: true,
      body: JSON.stringify({
        eventType,
        occurredAtUtc: new Date().toISOString(),
        metadata: normalizeMetadata(metadata),
      } satisfies EducationearchTelemetryPayload),
    });
  } catch {
    // Best-effort telemetry only.
  }
}
